import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { listMyGrns } from "@/lib/vendor-portal.functions";

export const Route = createFileRoute("/vendor/grns/")({
  component: GrnsIndex,
});

function GrnsIndex() {
  const fn = useServerFn(listMyGrns);
  const { data, isLoading } = useQuery({ queryKey: ["vendor", "grns"], queryFn: () => fn({}) });
  const grns = data?.grns ?? [];

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold">Deliveries (GRN)</h1>
      <div className="rounded-md border bg-card">
        {isLoading ? (
          <p className="p-4 text-sm text-muted-foreground">Loading…</p>
        ) : grns.length === 0 ? (
          <p className="p-4 text-sm text-muted-foreground">No goods receipts recorded yet.</p>
        ) : (
          <table className="w-full text-sm">
            <thead className="border-b bg-muted/40 text-xs uppercase text-muted-foreground">
              <tr>
                <th className="px-3 py-2 text-left">GRN No.</th>
                <th className="px-3 py-2 text-left">PO No.</th>
                <th className="px-3 py-2 text-left">Invoice</th>
                <th className="px-3 py-2 text-left">Received Date</th>
                <th className="px-3 py-2 text-left">Remarks</th>
              </tr>
            </thead>
            <tbody>
              {grns.map((g: any) => (
                <tr key={g.id} className="border-b last:border-0">
                  <td className="px-3 py-2 font-medium">{g.grn_no}</td>
                  <td className="px-3 py-2">{g.po_number ?? "—"}</td>
                  <td className="px-3 py-2">{g.invoice_no ?? "—"}</td>
                  <td className="px-3 py-2">{g.received_date ?? "—"}</td>
                  <td className="px-3 py-2 text-muted-foreground">{g.condition_remarks ?? "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
